'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addItem = addItem;
exports.addItemDeferred = addItemDeferred;
exports.addTemporaryItem = addTemporaryItem;
exports.addTemporaryItemDeferred = addTemporaryItemDeferred;
exports.removeCollection = removeCollection;
exports.removeCollectionDeferred = removeCollectionDeferred;
exports.updateCollection = updateCollection;
exports.updateCollectionDeferred = updateCollectionDeferred;
exports.revertCollection = revertCollection;
exports.revertCollectionDeferred = revertCollectionDeferred;
exports.revertCollectionKeys = revertCollectionKeys;
exports.revertCollectionKeysDeferred = revertCollectionKeysDeferred;
exports.saveCollection = saveCollection;
exports.saveCollectionDeferred = saveCollectionDeferred;
exports.saveCollectionKeys = saveCollectionKeys;
exports.saveCollectionKeysDeferred = saveCollectionKeysDeferred;
exports.updateItem = updateItem;
exports.updateItemDeferred = updateItemDeferred;
exports.removeItem = removeItem;
exports.removeItemDeferred = removeItemDeferred;
exports.restoreItem = restoreItem;
exports.restoreItemDeferred = restoreItemDeferred;
exports.saveItem = saveItem;
exports.saveItemDeferred = saveItemDeferred;
exports.saveItemKeys = saveItemKeys;
exports.saveItemKeysDeferred = saveItemKeysDeferred;
exports.revertItem = revertItem;
exports.revertItemDeferred = revertItemDeferred;
exports.revertItemKeys = revertItemKeys;
exports.revertItemKeysDeferred = revertItemKeysDeferred;

var _constants = require('./constants');

/*
 * COLLECTION ACTION CREATORS
 */
function addItem(collection) {
  var initialValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _collection$boundMeta = collection.boundMeta,
      reducer = _collection$boundMeta.reducer,
      dispatch = _collection$boundMeta.dispatch,
      dataSource = _collection$boundMeta.dataSource,
      group = _collection$boundMeta.group,
      filterName = _collection$boundMeta.filterName;

  dispatch(reducer.addDraft(dataSource, group, filterName, initialValues));
}

function addItemDeferred(collection, initialValues) {
  return collection.deferredAction('addItem', { initialValues: initialValues }, function () {
    return function () {
      addItem(collection, initialValues);
    };
  });
}

function addTemporaryItem(collection, id) {
  var serverValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _collection$boundMeta2 = collection.boundMeta,
      reducer = _collection$boundMeta2.reducer,
      dispatch = _collection$boundMeta2.dispatch,
      dataSource = _collection$boundMeta2.dataSource,
      group = _collection$boundMeta2.group,
      filterName = _collection$boundMeta2.filterName;

  dispatch(reducer.addServerTemporary(dataSource, group, filterName, id, serverValues));
}

function addTemporaryItemDeferred(collection, id, serverValues) {
  return collection.deferredAction('addTemporaryItem', { id: id, serverValues: serverValues }, function () {
    return function () {
      addTemporaryItem(collection, id, serverValues);
    };
  });
}

function removeCollection(collection) {
  var _collection$boundMeta3 = collection.boundMeta,
      reducer = _collection$boundMeta3.reducer,
      dispatch = _collection$boundMeta3.dispatch,
      dataSource = _collection$boundMeta3.dataSource,
      group = _collection$boundMeta3.group,
      filterName = _collection$boundMeta3.filterName;

  dispatch(reducer.removeDraft(dataSource, group, filterName, collection.reducerIDs));
}

function removeCollectionDeferred(collection) {
  return collection.deferredAction('removeCollection', {}, function () {
    return function () {
      removeCollection(collection);
    };
  });
}

function updateCollection(collection, changes) {
  var _collection$boundMeta4 = collection.boundMeta,
      reducer = _collection$boundMeta4.reducer,
      dispatch = _collection$boundMeta4.dispatch,
      dataSource = _collection$boundMeta4.dataSource,
      group = _collection$boundMeta4.group,
      filterName = _collection$boundMeta4.filterName;

  dispatch(reducer.updateDraft(dataSource, group, filterName, collection.reducerIDs, changes));
}

function updateCollectionDeferred(collection, changes) {
  return collection.deferredAction('updateCollection', {}, function () {
    return function () {
      updateCollection(collection, changes);
    };
  });
}

function revertCollection(collection) {
  var _collection$boundMeta5 = collection.boundMeta,
      reducer = _collection$boundMeta5.reducer,
      dispatch = _collection$boundMeta5.dispatch,
      dataSource = _collection$boundMeta5.dataSource,
      group = _collection$boundMeta5.group,
      filterName = _collection$boundMeta5.filterName;

  dispatch(reducer.revertDraft(dataSource, group, filterName, collection.reducerIDs, _constants.REVERT_ALL));
}

function revertCollectionDeferred(collection) {
  return collection.deferredAction('revertCollection', {}, function () {
    return function () {
      revertCollection(collection);
    };
  });
}

function revertCollectionKeys(collection, keys) {
  var _collection$boundMeta6 = collection.boundMeta,
      reducer = _collection$boundMeta6.reducer,
      dispatch = _collection$boundMeta6.dispatch,
      dataSource = _collection$boundMeta6.dataSource,
      group = _collection$boundMeta6.group,
      filterName = _collection$boundMeta6.filterName;

  dispatch(reducer.revertDraft(dataSource, group, filterName, collection.reducerIDs, keys));
}

function revertCollectionKeysDeferred(collection, keys) {
  return collection.deferredAction('revertCollectionKeys', { keys: keys }, function () {
    return function () {
      revertCollectionKeys(collection, keys);
    };
  });
}

function saveCollection(collection, options) {
  var _collection$boundMeta7 = collection.boundMeta,
      reducer = _collection$boundMeta7.reducer,
      dispatch = _collection$boundMeta7.dispatch,
      dataSource = _collection$boundMeta7.dataSource,
      group = _collection$boundMeta7.group,
      filterName = _collection$boundMeta7.filterName;

  dispatch(reducer.saveDraft(dataSource, group, filterName, collection.reducerIDs, _constants.SAVE_ALL, options));
}

function saveCollectionDeferred(collection, options) {
  return collection.deferredAction('saveCollection', {}, function () {
    return function () {
      saveCollection(collection, options);
    };
  });
}

function saveCollectionKeys(collection, keys, options) {
  var _collection$boundMeta8 = collection.boundMeta,
      reducer = _collection$boundMeta8.reducer,
      dispatch = _collection$boundMeta8.dispatch,
      dataSource = _collection$boundMeta8.dataSource,
      group = _collection$boundMeta8.group,
      filterName = _collection$boundMeta8.filterName;

  dispatch(reducer.saveDraft(dataSource, group, filterName, collection.reducerIDs, keys, options));
}

function saveCollectionKeysDeferred(collection, keys, options) {
  return collection.deferredAction('saveCollectionKeys', { keys: keys }, function () {
    return function () {
      saveCollectionKeys(collection, keys, options);
    };
  });
}

/*
 * ITEM ACTION CREATORS
 */
function updateItem(item, changes) {
  var _item$boundMeta = item.boundMeta,
      id = _item$boundMeta.id,
      reducer = _item$boundMeta.reducer,
      dispatch = _item$boundMeta.dispatch,
      dataSource = _item$boundMeta.dataSource,
      group = _item$boundMeta.group,
      filterName = _item$boundMeta.filterName;

  dispatch(reducer.updateDraft(dataSource, group, filterName, id, changes));
}

function updateItemDeferred(item, changes) {
  return item.deferredAction('updateItem', {}, function () {
    return function () {
      updateItem(item, changes);
    };
  });
}

function removeItem(item) {
  var _item$boundMeta2 = item.boundMeta,
      id = _item$boundMeta2.id,
      reducer = _item$boundMeta2.reducer,
      dispatch = _item$boundMeta2.dispatch,
      dataSource = _item$boundMeta2.dataSource,
      group = _item$boundMeta2.group,
      filterName = _item$boundMeta2.filterName;

  dispatch(reducer.removeDraft(dataSource, group, filterName, id));
}

function removeItemDeferred(item) {
  return item.deferredAction('removeItem', {}, function () {
    return function () {
      removeItem(item);
    };
  });
}

function restoreItem(item) {
  var _item$boundMeta3 = item.boundMeta,
      id = _item$boundMeta3.id,
      reducer = _item$boundMeta3.reducer,
      dispatch = _item$boundMeta3.dispatch,
      dataSource = _item$boundMeta3.dataSource,
      group = _item$boundMeta3.group,
      filterName = _item$boundMeta3.filterName;

  dispatch(reducer.restoreDraft(dataSource, group, filterName, id));
}

function restoreItemDeferred(item) {
  return item.deferredAction('restoreItem', {}, function () {
    return function () {
      restoreItem(item);
    };
  });
}

function saveItem(item) {
  var _item$boundMeta4 = item.boundMeta,
      id = _item$boundMeta4.id,
      reducer = _item$boundMeta4.reducer,
      dispatch = _item$boundMeta4.dispatch,
      dataSource = _item$boundMeta4.dataSource,
      group = _item$boundMeta4.group,
      filterName = _item$boundMeta4.filterName;

  return dispatch(reducer.saveDraft(dataSource, group, filterName, id, _constants.SAVE_ALL));
}

function saveItemDeferred(item) {
  return item.deferredAction('saveItem', {}, function () {
    return function () {
      saveItem(item);
    };
  });
}

function saveItemKeys(item, keys) {
  var _item$boundMeta5 = item.boundMeta,
      id = _item$boundMeta5.id,
      reducer = _item$boundMeta5.reducer,
      dispatch = _item$boundMeta5.dispatch,
      dataSource = _item$boundMeta5.dataSource,
      group = _item$boundMeta5.group,
      filterName = _item$boundMeta5.filterName;

  dispatch(reducer.saveDraft(dataSource, group, filterName, id, keys));
}

function saveItemKeysDeferred(item, keys) {
  return item.deferredAction('saveItemKeys', { keys: keys }, function () {
    return function () {
      saveItemKeys(item, keys);
    };
  });
}

function revertItem(item) {
  var _item$boundMeta6 = item.boundMeta,
      id = _item$boundMeta6.id,
      reducer = _item$boundMeta6.reducer,
      dispatch = _item$boundMeta6.dispatch,
      dataSource = _item$boundMeta6.dataSource,
      group = _item$boundMeta6.group,
      filterName = _item$boundMeta6.filterName;

  dispatch(reducer.revertDraft(dataSource, group, filterName, id, _constants.REVERT_ALL));
}

function revertItemDeferred(item) {
  return item.deferredAction('revertItem', {}, function () {
    return function () {
      revertItem(item);
    };
  });
}

function revertItemKeys(item, keys) {
  var _item$boundMeta7 = item.boundMeta,
      id = _item$boundMeta7.id,
      reducer = _item$boundMeta7.reducer,
      dispatch = _item$boundMeta7.dispatch,
      dataSource = _item$boundMeta7.dataSource,
      group = _item$boundMeta7.group,
      filterName = _item$boundMeta7.filterName;

  dispatch(reducer.revertDraft(dataSource, group, filterName, id, keys));
}

function revertItemKeysDeferred(item, keys) {
  return item.deferredAction('revertItemKeys', { keys: keys }, function () {
    return function () {
      revertItemKeys(item, keys);
    };
  });
}